import React, { Component } from "react";
import { Row, Grid, Glyphicon } from "react-bootstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import linkedIn from "../../../../../assets/images/linked-in-black.svg";
import whitePage from "../../../../../assets/images/whitePage.svg";
import website from "../../../../../assets/images/website.svg";
import { formatDateMedium } from "../../../../../utils/dates";
import moment from "moment";
import ScrollToTopOnMount from "../../../../../utils/scroll/ScrollToTopOnMount";
import styles from "./MemberProfile.scss";
import { userHasRole } from "../../../../../actions/user.actions";

const STATUS_ID_SUSPENDED = 2;
const STATUS_ID_BLOCKED = 3;
const STATUS_ID_APPLIED = 5;
const STATUS_ID_APPROVED = 8;

const INDUSTRY_OTHER = 38;

class MemberProfile extends Component {
  validURL(url) {
    //'http://' + _.get(memberData, 'links[0].url', '#')
    if (url) {
      if (url.search("http://") != -1) {
        return url;
      } else if (url.search("https://") != -1) {
        return url;
      } else {
        return `http://${url}`;
      }
    } else {
      return "#";
    }
  }

  getIndustryValue(industry, industry_other) {
    const id = _.get(industry, "id");
    const value = _.get(industry, "value");
    const other = industry_other || "-";

    if (value) {
      return id === INDUSTRY_OTHER ? `${value}: ${other}` : value;
    } else {
      return "-";
    }
  }

  getStatusLogDate(log, status_id) {
    if (!log || log.length <= 0) return undefined;
    let date = log
      .filter(e => e.status_id === status_id)
      .map(e => e.modified_at);
    if (!date || date.length === 0) return undefined;
    return date.reduce((p, c) => (p > c ? p : c));
  }

  getMemberName(member) {
    return (member.first_name || "") + " " + (member.last_name || "");
  }

  render() {
    const { memberData } = this.props;

    const skillsList =
      !_.isEmpty(memberData.skills) &&
      memberData.skills.map((skill, index) => (
        <li key={index}>{skill.description.name}</li>
      ));

    const workHistoryList =
      !_.isEmpty(memberData.work_history) &&
      memberData.work_history.map((work, index) => (
        <div key={index}>
          <div>{index === 0 ? "" : <div className={styles.divider} />}</div>
          <h3>{_.get(work, "company.name")}</h3>
          <p className={styles.historyContent}>
            {work.role} | {work.years}
            {work.years > 1 ? " years" : " year"}
          </p>
        </div>
      ));

    const signedUp = _.get(memberData, "created_at");
    const lastLogin = _.get(memberData, "last_login_at");

    const appliedDate = this.getStatusLogDate(
      memberData.log,
      STATUS_ID_APPLIED
    );

    const approvedDate = this.getStatusLogDate(
      memberData.log,
      STATUS_ID_APPROVED
    );

    const blockedDate = this.getStatusLogDate(
      memberData.log,
      STATUS_ID_BLOCKED
    );

    const suspendedDate = this.getStatusLogDate(
      memberData.log,
      STATUS_ID_SUSPENDED
    );

    const educationList =
      !_.isEmpty(memberData.education) &&
      memberData.education.map((education, index) => (
        <div key={index}>
          <div>{index === 0 ? "" : <div className={styles.divider} />}</div>
          <h3>{education.school.value}</h3>
          <p className={styles.historyContent}>{education.degree}</p>
        </div>
      ));

    const linksList =
      !_.isEmpty(memberData.links) &&
      memberData.links.map((link, index) => {
        let url = link.url;
        if (!url) return null;
        if (url.indexOf("http://") < 0 && url.indexOf("https://") < 0)
          url = "//" + url;

        return (
          <div key={index}>
            {link.category.indexOf("linkedin") >= 0 && (
              <div>
                {index > 0 && <div className={styles.divider} />}
                <div className={styles.linksFlex}>
                  <p>
                    <img src={linkedIn} className={styles.logos} />
                    <span className={styles.materialsSpan}>LinkedIn</span>
                    <a href={url} target="_blank">
                      {link.url}
                    </a>
                  </p>
                </div>
              </div>
            )}
            {link.category.indexOf("website") >= 0 && (
              <div>
                {index > 0 && <div className={styles.divider} />}
                <div className={styles.linksFlex}>
                  <p>
                    <img src={website} className={styles.logos} />
                    <span className={styles.materialsSpan}>Website</span>
                    <a href={url} target="_blank">
                      {link.url}
                    </a>
                  </p>
                </div>
              </div>
            )}
          </div>
        );
      });

    return (
      <section className={styles.memberProfileContainer}>
        <ScrollToTopOnMount />
        <section className={styles.textFont}>
          <Grid className={styles.maxWidth}>
            <div
              className={classnames(
                styles.editLink,
                styles.editLinkTitle,
                "row"
              )}
            >
              <h1 className={styles.header}>
                {this.getMemberName(memberData)}
              </h1>
              <Link to="profile/email">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
            </div>
            <Row>
              <div className={styles.divider} />
              <div className={styles.divider} />
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Roles</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                {userHasRole(memberData.roles, "member") && (
                  <div>
                    {signedUp && (
                      <div>
                        <span className={styles.userAccountTitle}>Member</span>
                        <span>
                          {" "}
                          signed up on{" "}
                          {moment(signedUp).format("MMMM DD, YYYY")}
                        </span>
                      </div>
                    )}
                    {approvedDate && (
                      <div>
                        <span className={styles.userAccountTitle}>Member</span>
                        <span>
                          {" "}
                          approved on{" "}
                          {moment(approvedDate).format("MMMM DD, YYYY")}
                        </span>
                      </div>
                    )}
                    {blockedDate && (
                      <div>
                        <span className={styles.userAccountTitle}>Member</span>
                        <span>
                          {" "}
                          blocked on{" "}
                          {moment(blockedDate).format("MMMM DD, YYYY")}
                        </span>
                      </div>
                    )}
                    {suspendedDate && (
                      <div>
                        <span className={styles.userAccountTitle}>Member</span>
                        <span>
                          {" "}
                          suspended on{" "}
                          {moment(suspendedDate).format("MMMM DD, YYYY")}
                        </span>
                      </div>
                    )}
                    {lastLogin && (
                      <div>
                        <span className={styles.userAccountTitle}>
                          Last login:
                        </span>
                        <span>
                          {" "}
                          {moment(lastLogin).format("MMMM DD, YYYY")}
                        </span>
                      </div>
                    )}
                  </div>
                )}
                {userHasRole(memberData.roles, "admin") && (
                  <p>
                    {appliedDate && (
                      <div>
                        <span className={styles.userAccountTitle}>Admin</span>
                        <span>
                          {" "}
                          assigned on{" "}
                          {moment(appliedDate).format("MMMM DD, YYYY")}
                        </span>
                      </div>
                    )}
                  </p>
                )}
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Contact</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <p>
                  <span className={styles.userAccountTitle}>Email: </span>
                  <a href={`mailto:${_.get(memberData, "email")}`}>
                    {_.get(memberData, "email")}
                  </a>
                </p>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Status</h2>
              <Link to="profile/summary">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
              &nbsp;
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <p>
                  <span className={styles.userAccountTitle}>Location: </span>
                  <span>{_.get(memberData, "profile.city")}</span>
                </p>
                <p>
                  <span className={styles.userAccountTitle}>
                    Nearest Metro:{" "}
                  </span>
                  <span>{_.get(memberData, "profile.commute_city.value")}</span>
                </p>
                <p>
                  <span className={styles.userAccountTitle}>Level: </span>
                  <span>{_.get(memberData, "profile.level.value")}</span>
                </p>
                <p>
                  <span className={styles.userAccountTitle}>
                    Primary Industry:{" "}
                  </span>
                  <span>
                    {this.getIndustryValue(
                      _.get(memberData, "profile.primary_industry"),
                      _.get(memberData, "profile.primary_industry_other")
                    )}
                  </span>
                </p>
                <p>
                  <span className={styles.userAccountTitle}>
                    Secondary Industry:{" "}
                  </span>
                  <span>
                    {this.getIndustryValue(
                      _.get(memberData, "profile.secondary_industry"),
                      _.get(memberData, "profile.secondary_industry_other")
                    )}
                  </span>
                </p>
                <p>
                  <span className={styles.userAccountTitle}>Referrer: </span>
                  <span>
                    {_.get(memberData, "profile.referral_type.value")}
                    {_.get(memberData, "profile.referral_value")
                      ? ` - ${_.get(memberData, "profile.referral_value")}`
                      : ""}
                  </span>
                </p>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Summary</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <div className={styles.summarySection}>
                  {_.get(memberData, "profile.professional_summary")}
                </div>
                <div className={styles.divider} />
                <p className={styles.summarySubheader}>
                  {_.get(memberData, "profile.full_time_job")
                    ? "This member is available for a full-time, on-staff role."
                    : "This member is not available for a full-time, on-staff role."}
                </p>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Additional Materials</h2>
              <Link to="profile/additional-materials">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
              &nbsp;
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <div className={styles.linksFlex}>
                  <p>
                    <img src={whitePage} className={styles.logos} />
                    <span className={styles.materialsSpan}>Resumé </span>
                    {memberData &&
                    memberData.profile &&
                    memberData.profile.resume ? (
                      <span>
                        <Link
                          to="#"
                          onClick={this.props.downloadResume}
                          data-download="false"
                        >
                          Download
                        </Link>
                      </span>
                    ) : (
                      <small>- No resumé available -</small>
                    )}
                  </p>
                </div>

                <div className={styles.divider} />
                <div> {linksList} </div>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Skills</h2>
              <Link to="profile/skills">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
              &nbsp;
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <ul>{skillsList}</ul>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Work History</h2>
              <Link to="profile/work-history">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
            </div>
            <Row>
              <div className={styles.whiteBackground}>{workHistoryList}</div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Education</h2>
              <Link to="profile/education">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
            </div>
            <Row>
              <div className={styles.whiteBackground}>{educationList}</div>
            </Row>
          </Grid>
        </section>
      </section>
    );
  }

  renderMemberStatusText() {
    const memberLog = this.props.memberData.log;

    if (!_.isEmpty(memberLog)) {
      const log = memberLog[memberLog.length - 1];
      const modifiedAtDate = _.get(log, "modified_at");
      const statusName = _.get(log, "status.name");
      const modifiedAtDateFormatted = formatDateMedium(modifiedAtDate);

      const possibleValues = {
        applied: `Applied since ${modifiedAtDateFormatted}`,
        "waiting-for-references": `References request sent on ${modifiedAtDateFormatted}`,
        "pending-interview": `References approved on ${modifiedAtDateFormatted}`,
        approved: `Accepted on ${modifiedAtDateFormatted}`,
        rejected: `Rejected on ${modifiedAtDateFormatted}`
      };

      return possibleValues[statusName] || possibleValues["applied"];
    }
  }
}

export default MemberProfile;



// WEBPACK FOOTER //
// ./src/routes/admin/member/profile/components/MemberProfile.js